import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {};
const defaultProps = {};

function HelpDashboard(props) {
    return (
        <div>
            Help Dashboard
        </div>
    );
}

HelpDashboard.propTypes = propTypes;
HelpDashboard.defaultProps = defaultProps;

export default HelpDashboard;
